export default { 
    HOUR: "hou", 
    DAY: "day",
    HOUR_UPPER: "HOU", 
    DAY_UPPER: "DAY"
};